'use client'

import { useEffect } from 'react'

export default function AOSInitializer() {
  useEffect(() => {
    let disposed = false

    const ensureAOSStyles = () => {
      if (document.querySelector('link[data-aos-style="lite"]')) return

      const link = document.createElement('link')
      link.rel = 'stylesheet'
      link.href = '/css/aos-lite.css'
      link.media = 'print'
      link.setAttribute('data-aos-style', 'lite')
      link.onload = () => {
        link.media = 'all'
      }

      document.head.appendChild(link)
    }

    const initAOS = async () => {
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return
      // AOS ya tiene disable:'phone', pero saltarse el import evita parsear el chunk en móvil
      if (window.matchMedia('(max-width: 767px)').matches) return

      ensureAOSStyles()
      const { default: AOS } = await import('aos')

      if (disposed) return

      AOS.init({
        once: true,
        disable: 'phone',
        duration: 600,
        easing: 'ease-out-sine',
        startEvent: 'DOMContentLoaded',
      })
    }

    void initAOS()

    return () => {
      disposed = true
    }
  }, [])

  return null
}
